import { lazy, Suspense, type ReactNode } from 'react'
import type { RouteObject } from 'react-router'
import { Layout } from './components/Layout'
import { Spinner } from './components/ui'
import { Home } from './pages/Home'
import { NotFound } from './pages/NotFound'

const Course = lazy(() => import('./pages/Course'))
const Info = lazy(() => import('./pages/Info'))
const Register = lazy(() => import('./pages/register/Register'))
const Confirmation = lazy(() => import('./pages/register/Confirmation'))
const DemoPayment = lazy(() => import('./pages/register/DemoPayment'))
const Participants = lazy(() => import('./pages/Participants'))
const Results = lazy(() => import('./pages/Results'))
const Volunteer = lazy(() => import('./pages/Volunteer'))
const Faq = lazy(() => import('./pages/Faq'))
const Policies = lazy(() => import('./pages/Policies'))
const Admin = lazy(() => import('./pages/admin/Admin'))
const Donate = lazy(() => import('./pages/donate/Donate'))
const DonatePay = lazy(() => import('./pages/donate/DonatePay'))
const DonateThanks = lazy(() => import('./pages/donate/Thanks'))
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'))

const page = (el: ReactNode) => <Suspense fallback={<Spinner />}>{el}</Suspense>

export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'course', element: page(<Course />) },
      { path: 'info', element: page(<Info />) },
      { path: 'register', element: page(<Register />) },
      { path: 'register/confirmation', element: page(<Confirmation />) },
      { path: 'register/pay', element: page(<DemoPayment />) },
      { path: 'donate', element: page(<Donate />) },
      { path: 'donate/pay', element: page(<DonatePay />) },
      { path: 'donate/thanks', element: page(<DonateThanks />) },
      { path: 'participants', element: page(<Participants />) },
      { path: 'results', element: page(<Results />) },
      { path: 'volunteer', element: page(<Volunteer />) },
      { path: 'faq', element: page(<Faq />) },
      { path: 'policies', element: page(<Policies />) },
      { path: 'unsubscribe', element: page(<Unsubscribe />) },
      { path: 'admin/*', element: page(<Admin />) },
      { path: '*', element: <NotFound /> },
    ],
  },
]
